import { render } from "./footer.vue?vue&type=template&id=64090622"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=64090622&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__